module.exports = __webpack_public_path__ + "img/Group16.d2ecd4dd.png";